import { defineStore } from "pinia";

import { getCompanyId } from "@/utils/userUtils";

import fleetParksApi from "@/services/api/fleetParksApi";
import { useNotificationStore } from "@/stores/notificationStore";

export const useFleetParkStore = defineStore("fleetPark", {
  state: () => ({
    fleetParks: [],
    companyId: getCompanyId(),
    dataIsLoading: false,
    isSubmitting: false,
  }),

  getters: {
    fleetParkSelectOptions: (state) =>
      state.fleetParks
        .filter((park) => !park.archived_at)
        .map((park) => ({
          value: park.id,
          label: park.name,
        })),
  },

  actions: {
    async fetchFleetParks(params = {}) {
      this.dataIsLoading = true;

      try {
        const response = await fleetParksApi.index(
          this.companyId,
          params
        );
        this.fleetParks = response.data.result;
      } finally {
        this.dataIsLoading = false;
      }
    },

    async createFleetPark(payload) {
      this.isSubmitting = true;

      try {
        const response = await fleetParksApi.create(
          this.companyId,
          payload
        );
        const fleetPark = response.data.result;

        await this.fetchFleetParks();
        useNotificationStore().showSuccess("Автопарк создан");

        return fleetPark;
      } finally {
        this.isSubmitting = false;
      }
    },

    async updateFleetPark(id, payload) {
      this.isSubmitting = true;

      try {
        const response = await fleetParksApi.update(
          this.companyId,
          id,
          payload
        );
        const fleetPark = response.data.result;

        await this.fetchFleetParks();
        useNotificationStore().showSuccess("Автопарк обновлен");

        return fleetPark;
      } finally {
        this.isSubmitting = false;
      }
    },
  },
});
